import styled, {css} from 'styled-components';

export const SearchBarConatiner = styled.div`
  margin: 15px 0px;
  background: #19213e;
  padding: 10px 100px;
  border-radius: 10px;

  & > .form-row {
    margin: 5px 0px;
  }

  & .search-condition {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0 10px;
    color: #757e94;
    font-size: 14px;
    font-weight: bold;

    & label {
      width: 65px;
      margin: 0px 10px 0px 0px;
    }

    & span {
      margin: 0px 10px;
    }

    & > .table-search-input {
      width: 190px;
      height: 28px;
      margin: 0px 10px;
      padding: 0px 10px;
      color: #fff;
      font-size: 14px;
      font-weight: 400;
      line-height: 1.5;
      background: #171e3a;
      border: .5px solid #31373e;
      border-radius: .25rem;
      transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;

      &:disabled, &:disabled {
        background: #292929;
        color: #888e95;
      }
    }

    & > .table-search-submit {
      width: 200px;
      height: 30px;
      line-height: 1;
      font-size: 13px;
    }
  }
`;

export const TableSearchInput = styled.select`
  height: 28px;
  padding: 0px 10px;
  margin: 0px 10px;
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  background: #171e3a;
  border: .5px solid #31373e;
  border-radius: .25rem;
  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;

  ${props => 
    props.option === "custom" ? css`width: calc(100% - 110px);` : (
      props.option === "week" ? css`width: calc((100% - 110px) / 5);` : (
        props.option === "month" ? css`width: calc((100% - 110px) / 4);` : (
          props.option === "quarter" ? css`width: calc((100% - 110px) / 4);` : (
            props.option === "year" && css`width: calc((100% - 110px) / 2);`
          )
        )
      )
    )
  }
`